import { createContext } from 'react'

const TagsContext = createContext({
  tagsModalShow: () => null ,
  tagsModalHide: () => null ,
  tagsModal: null,
  tagId:null   
})

export default TagsContext;